/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.2",
    versionName: "0.2.0-nightly.2025.11.2",
    versionChannel: "nightly",
    buildDate: "2025-11-02T00:08:12.162Z",
    commitHash: "a452655421e43b4a5a28419a57162c8c8901e9d5",
};
